import { computed, inject, Injectable, signal } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { tap, switchMap } from 'rxjs';
import { UserDataResponse } from '../../shared/interfaces/user-data-response.interface';
import { UserDataDetailResponse } from '../../shared/interfaces/user-data-detail-response.interface';
import { UserPointsHistoryResponse } from '../../shared/interfaces/user-points-history-response.interface';
import { UserHistoryAwardResponse } from '../../shared/interfaces/user-history-award-response.interface';

@Injectable({ providedIn: 'root' })
export class UserDataService {
  private userService = inject(UserService);

  private _userData = signal<UserDataResponse | null>(null);
  private _userDataDetail = signal<UserDataDetailResponse | null>(null);
  private _nationalSales = signal<UserPointsHistoryResponse[]>([]);
  private _addOns = signal<UserPointsHistoryResponse[]>([]);
  private _dynamo = signal<UserPointsHistoryResponse[]>([]);
  private _historyAwards = signal<UserHistoryAwardResponse[]>([]);

  userData = computed(() => this._userData());
  userDataDetail = computed(() => this._userDataDetail());
  userName = computed(
    () =>
      `${this._userData()?.name || ''} ${this._userData()?.lastName || ''} ${
        this._userData()?.secondLastName || ''
      }`,
  );
  hasInfoComplete = computed(
    () =>
      this._userData()?.cellphoneNumber !== null &&
      this._userData()?.cellphoneNumber !== '',
  );
  nationalSales = computed(() => this._nationalSales());
  addOns = computed(() => this._addOns());
  dynamo = computed(() => this._dynamo());
  historyAwards = computed(() => this._historyAwards());

  constructor() {
    this.getUserInfo();
  }

  getUserInfo() {
    this.userService
      .getUserData()
      .pipe(
        tap((userData) => this._userData.set(userData)),
        switchMap(() => this.userService.getUserDataDetail()),
      )
      .subscribe({
        next: (value) => this._userDataDetail.set(value),
      });
  }
}
